import { DefaultTheme } from 'styled-components';

const light: DefaultTheme = {
  title: 'light',
  colors: {
    primary: '#408CFE',
    secundary: '#28CE6B', // '#21d268',
    default: '#c8c8c8',
    body: '#EEF0F8', // '#f9fdff',
    modules: '#FFFFFF',
    secoundary_body: '#ececec', // '#f4f8fb',
    background: '#eef0f8',
    header_background: '#ffffff',
    dashboard_card_bg: '#ffffff',
    container_background: '#ffffff',
    container_title: '#181c32',
    container_header_border: '#e5eaee',
    sidebar: '#1F1E2C',
    sidebarLinear: '#141414',
    sidebarPerfil: '#222222',
    iconFill: '#FFFFFF',
    thead: '#F2F2F2',
    tbodyZebra: '#FBFBFB',
    backgroundIcon: '#f3f3f3',
    text: '#FFFFFF',
    secoundary_text: '#a5a5a5',
    title: '#404040',
    hyperLink: '#12AAFF',
    textTable: '#505050',
    table_row_line: '#e5eaee',
    table_column_title: '#b5b5c3',
    table_bg: '#fff',
    description: '#A8a8a8',
    sidebarLink: '#adadad',
    sidebarSelected: '#3B4146',
    sidebarSelectedLink: '#DDDDDD',
    input: '#ffffff',
    borderInput: '#e5eaee',
    placeholder: '#B0B0B0',
    placeholderSelected: '#555555',
    details: '#B5B5C3',
    backgroundModule_1: '#f3f7fa',
    backgroundModule_2: '#eef3f7',
    backgroundModule_3: '#e5ecf2',
    titleModule: '#5E5F62',
    descriptionModule: '#99aac4',
    backgroundLogoutButton: '#f1f1f1',
    textLogoutButton: '#606060',
    iconLogoutButton: '#828282',
    logo: '#262626',
    line: '#E1E1E1',
    success: '#DEF8E9',
    successText: '#59DE8F',
    error: '#F8DEDE',
    errorText: '#DE5959',
    lineTable: '#f6f6f6',
    total: '#FFFFFF',
    select_text: '#606060',
    arrow: '#4f4f4f',
    besni: '#ee2e2a',
    actions: '#f2f2f2',
    disabledInput: '#f2f2f2',
    disabledText: '#B5B5C3',
    progress_background: '#dddddd',
    counter_background: '#f2f2f2',
    counter_color: '#606060',
    value_color: '#999999',
    page_background: '#eef0f8',
    content_box_background: '#ffffff',
    input_border_color: '#e5eaee',
    input_placeholder_color: '#B0B0B0',
    title_color: '#181c32',
    action_button_color: '#408CFE',
    clear_button_color: '#ff3b4c',
    filter_button_not_expanded_color: '#28CE6B',
    filter_button_expanded_color: '#F1BC00',
    environmentTypes: {
      dev: {
        bg: '#FFF5F8',
        color: '#D9214E',
      },
      homol: {
        bg: '#FFF8DD',
        color: '#F1BC00',
      },
      prod: {
        bg: '#E8FFF3',
        color: '#46BE7D',
      },
    },
    // dashboardCard: 0,
    dashboardCard1: '#3A86FF',
    dashboardCard2: '#064AB8',
    dashboardCard3: '#56DE02',
    dashboardCard4: '#58E600',
    dashboardCard5: '#FA2878',
    dashboardCard6: '#ffbd00',
    dashboardCard7: '#ff0054',
    switchButtonMarkedBg: '#E8FFF3',
    switchButtonMarkedCircle: '#50CD89',
    switchButtonMarkedInnerCircle: '#FFFFFF',
    switchButtonUnmarkedBg: '#EFF2F5',
    switchButtonUnmarkedCircle: '#6D6D80',
    switchButtonUnmarkedInnerCircle: '#FFFFFF',
    tagStatusColors: {
      em_andamento_or_inativo: {
        color: '#F1BC00',
        bg: '#FFF8DD',
      },
      cancelado: {
        color: '#3F4254',
        bg: '#A1A5B7',
      },
      finalizado_divergente_or_bloqueado: {
        color: '#D9214E',
        bg: '#FFF5F8',
      },
      finalizado_or_ativo: {
        color: '#46BE7D',
        bg: '#E8FFF3',
      },
      pendente: {
        color: '#B5B5C3',
        bg: '#EFF2F5',
      },
      aguardando_faturamento_or_integracao_or_expedicao: {
        color: '#F69B11',
        bg: '#FFF5E6',
      },
      andamento: {
        color: '#F1BC00',
        bg: '#FFF8DD',
      },
      ressuprimento: {
        color: '#58244B',
        bg: '#FBF1F8',
      },
      expedicao_finalizada_or_aguardando_conferencia: {
        color: '#4A7DFF',
        bg: '#F1F5FF',
      },
      pedido_cancelado: {
        color: '#3F4254',
        bg: '#A1A5B7',
      },
      criado: {
        color: '#B5B5C3',
        bg: '#EFF2F5',
      },
    },
    danger: '#ff3b4c',
    tagTextColors: [
      {
        name: 'ativo',
        value: '#59DE8F',
        customized: false,
      },
      {
        name: 'inativo',
        value: '#DE5959',
        customized: false,
      },
      {
        name: 'Aguardando',
        value: '#03a9f4',
        customized: false,
      },
      {
        name: 'Divergente',
        value: '#ef5350',
        customized: false,
      },
      {
        name: 'Estoque Insuficiente',
        value: '#ef5350',
        customized: false,
      },
      {
        name: 'Em andamento',
        value: '#ff9800',
        customized: false,
      },
      {
        name: 'Bloqueado',
        value: '#ff9800',
        customized: false,
      },
      {
        name: 'Andamento',
        value: '#ff9800',
        customized: false,
      },
      {
        name: 'Ressuprimento',
        value: '#ff9800',
        customized: false,
      },
      {
        name: 'Integrado Ok',
        value: '#2e9d33',
        customized: false,
      },
      {
        name: 'Integrado divergente',
        value: '#5000edbd',
        customized: false,
      },
      {
        name: 'Aguardando Conferência',
        value: '#5000edbd',
        customized: false,
      },
      {
        name: 'Aguardando Expedição',
        value: '#5000edbd',
        customized: false,
      },
      {
        name: 'Finalizado divergente',
        value: '#ffb100',
        customized: false,
      },
      {
        name: 'Finalizado c/divergência',
        value: '#ffb100',
        customized: false,
      },
      {
        name: 'Pendente',
        value: '#03a9f4',
        customized: false,
      },
      {
        name: 'Planejado',
        value: '#03a9f4',
        customized: false,
      },
      {
        name: 'Ok',
        value: '#4caf50',
        customized: false,
      },
      {
        name: 'Criado',
        value: '#4caf50',
        customized: false,
      },
      {
        name: 'Finalizado',
        value: '#4caf50',
        customized: false,
      },
      {
        name: 'Expedição Finalizada',
        value: '#4caf50',
        customized: false,
      },
    ],
    tagBackgroundColors: [
      {
        name: 'ativo',
        value: '#DEF8E9',
        customized: false,
      },
      {
        name: 'inativo',
        value: '#F8DEDE',
        customized: false,
      },
      {
        name: 'Aguardando',
        value: '#03a9f440',
        customized: false,
      },
      {
        name: 'Divergente',
        value: '#ef535040',
        customized: false,
      },
      {
        name: 'Estoque Insuficiente',
        value: '#ef535040',
        customized: false,
      },
      {
        name: 'Em andamento',
        value: '#ff980040',
        customized: false,
      },
      {
        name: 'Bloqueado',
        value: '#ff980040',
        customized: false,
      },
      {
        name: 'Andamento',
        value: '#ff980040',
        customized: false,
      },
      {
        name: 'Ressuprimento',
        value: '#ff980040',
        customized: false,
      },
      {
        name: 'Integrado Ok',
        value: '#329a1840',
        customized: false,
      },
      {
        name: 'Integrado divergente',
        value: '#5223c638',
        customized: false,
      },
      {
        name: 'Aguardando Conferência',
        value: '#5223c638',
        customized: false,
      },
      {
        name: 'Aguardando Expedição',
        value: '#5223c638',
        customized: false,
      },
      {
        name: 'Finalizado divergente',
        value: '#ffb10040',
        customized: false,
      },
      {
        name: 'Finalizado c/divergência',
        value: '#ffb10040',
        customized: false,
      },
      {
        name: 'Pendente',
        value: '#03a9f440',
        customized: false,
      },
      {
        name: 'Planejado',
        value: '#03a9f440',
        customized: false,
      },
      {
        name: 'Ok',
        value: '#4caf5040',
        customized: false,
      },
      {
        name: 'Criado',
        value: '#4caf5040',
        customized: false,
      },
      {
        name: 'Finalizado',
        value: '#4caf5040',
        customized: false,
      },
      {
        name: 'Expedição Finalizada',
        value: '#4caf5040',
        customized: false,
      },
    ],
  },
};

export default light;
